import * as requestFromServer from "./dashboardCrud";
import { dashboardSlice, callTypes } from "./dashboardSlice";
import { toast } from "react-hot-toast";
import { AppDispatch } from "../store";

const { actions } = dashboardSlice;

// Only the latest request may update the KPIs: switching the funnel on/off or changing dates
// quickly must not let an older, slower response overwrite the newer one.
let latestAnalyticsRequest = 0;

export const getDashboardAnalytics = (data?: any) => (dispatch: AppDispatch | any) => {
  const requestId = ++latestAnalyticsRequest;
  dispatch(
    actions.startCall({
      callType: callTypes.list,
    }),
  );
  return requestFromServer
    .getDashboardAnalytics(data)
    .then((response) => {
      if (requestId !== latestAnalyticsRequest) return;
      dispatch(
        actions.getDashboardAnalytics({
          results: response?.data.results,
        }),
      );
    })
    .catch((error) => {
      if (requestId !== latestAnalyticsRequest) return;
      error.clientMessage = error.message;
      dispatch(
        actions.catchError({
          error,
          callType: callTypes.action,
        }),
      );
      toast.error(error?.response?.data?.message);
    });
};
